<span class="mr-small" *ngIf="menu">
  <button mat-stroked-button [matMenuTriggerFor]="menu" color="primary">
    {{ filterName }} <mat-icon>arrow_drop_down</mat-icon>
  </button>
</span>
